// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3npfI","delete":"styles_delete__3QZCW","update":"styles_update__1fyMa","add":"styles_add__2SJWM"};